import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { callCreateNewClient } from './firebase'; // 🔥 استيراد الدالة المساعدة

function SignupPage() {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    brandName: '',
    telegramId: '',
    countryCode: '20',
    facebookUrl: '',
    instagramUrl: '',
    platform: 'shopify', // default
    shopifyDomain: '',
    shopifyAccessToken: '',
    easyOrderDomain: '',
    easyOrderStoreId: '',
    easyOrderApiKey: '',
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      // إرسال البيانات للـ Cloud Function
      const result = await callCreateNewClient(formData);

      if (result.status === 'success') {
        alert('تم إنشاء الحساب بنجاح! جاري تحويلك لإعداد الـ Webhook...');
        navigate('/dashboard');
      } else {
        setError(result.message || 'حدث خطأ غير معروف');
      }
    } catch (error) {
      if (error.message.includes('already-exists') || error.message.includes('مسجل بالفعل') || error.message.includes('مستخدم')) {
        setError(error.message || 'الاسم أو البيانات مسجلة بالفعل');
      } else {
        setError(error.message);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px 0' }}>
      <div style={{ background: 'rgba(30, 30, 47, 0.95)', borderRadius: '20px', padding: '40px', boxShadow: '0 20px 60px rgba(0, 0, 0, 0.5)', maxWidth: '600px', width: '100%', margin: '0 20px' }}>
        <h2 style={{textAlign: 'center', color: '#8be9fd', marginBottom: '10px'}}>إنشاء حساب براند جديد</h2>
        <p style={{textAlign: 'center', color: '#f8f8f2', marginBottom: '30px', fontSize: '14px'}}>املأ البيانات التالية لإنشاء حسابك</p>
        
        <form onSubmit={handleSubmit}>
          <div style={fieldGroupStyle}>
            <label style={labelStyle}>الإيميل</label>
            <input 
              type="email" 
              name="email" 
              placeholder="أدخل البريد الإلكتروني" 
              value={formData.email} 
              onChange={handleChange} 
              required 
              style={inputStyle} 
            />
          </div>
          
          <div style={fieldGroupStyle}>
            <label style={labelStyle}>كلمة المرور</label>
            <input 
              type="password" 
              name="password" 
              placeholder="أدخل كلمة المرور" 
              value={formData.password} 
              onChange={handleChange} 
              required 
              style={inputStyle} 
            />
          </div>
          
          <div style={fieldGroupStyle}>
            <label style={labelStyle}>اسم البراند</label>
            <input 
              type="text" 
              name="brandName" 
              placeholder="اسم البراند (مهم: ده هيكون اسم الدوكيومنت)" 
              value={formData.brandName} 
              onChange={handleChange} 
              required 
              style={inputStyle} 
            />
          </div>
          
          <div style={fieldGroupStyle}>
            <label style={labelStyle}>Telegram ID</label>
            <input 
              type="text" 
              name="telegramId" 
              placeholder="مثال: @username أو 123456789" 
              value={formData.telegramId} 
              onChange={handleChange} 
              required 
              style={inputStyle} 
            />
          </div>
          
          <div style={fieldGroupStyle}>
            <label style={labelStyle}>كود الدولة</label>
            <input 
              type="text" 
              name="countryCode" 
              placeholder="افتراضي: 20" 
              value={formData.countryCode} 
              onChange={handleChange} 
              style={inputStyle} 
            />
          </div>
          
          <div style={{ background: 'rgba(40, 42, 54, 0.5)', padding: '20px', borderRadius: '12px', margin: '20px 0' }}>
            <h3 style={{ color: '#8be9fd', marginBottom: '20px', fontSize: '16px', textAlign: 'center' }}>روابط التواصل الاجتماعي (اختياري)</h3>
            
            <div style={fieldGroupStyle}>
              <label style={labelStyle}>Facebook URL</label>
              <input 
                type="url" 
                name="facebookUrl" 
                placeholder="رابط صفحة الفيسبوك" 
                value={formData.facebookUrl} 
                onChange={handleChange} 
                style={inputStyle} 
              />
            </div>
            
            <div style={fieldGroupStyle}>
              <label style={labelStyle}>Instagram URL</label>
              <input 
                type="url" 
                name="instagramUrl" 
                placeholder="رابط حساب الانستجرام" 
                value={formData.instagramUrl} 
                onChange={handleChange} 
                style={inputStyle} 
              />
            </div>
          </div>
          
          <div style={fieldGroupStyle}>
            <label style={labelStyle}>المنصة</label>
            <select 
              name="platform" 
              value={formData.platform} 
              onChange={handleChange} 
              required 
              style={inputStyle}
            >
              <option value="shopify">🛍️ Shopify</option>
              <option value="easyorder">📦 EasyOrder</option>
            </select>
          </div>
          
          {formData.platform === 'shopify' && (
            <div style={{ background: 'rgba(40, 42, 54, 0.5)', padding: '20px', borderRadius: '12px', margin: '20px 0' }}>
              <h3 style={{ color: '#8be9fd', marginBottom: '20px', fontSize: '16px', textAlign: 'center' }}>بيانات Shopify</h3>
              
              <div style={fieldGroupStyle}>
                <label style={labelStyle}>دومين شوبيفاي</label>
                <input 
                  type="text" 
                  name="shopifyDomain" 
                  placeholder="مثال: my-store.myshopify.com" 
                  value={formData.shopifyDomain} 
                  onChange={handleChange} 
                  required 
                  style={inputStyle} 
                />
              </div>
              
              <div style={fieldGroupStyle}>
                <label style={labelStyle}>Shopify Access Token</label>
                <input 
                  type="text" 
                  name="shopifyAccessToken" 
                  placeholder="أدخل توكن الوصول" 
                  value={formData.shopifyAccessToken} 
                  onChange={handleChange} 
                  required 
                  style={inputStyle} 
                />
              </div>
            </div>
          )}
          
          {formData.platform === 'easyorder' && (
            <div style={{ background: 'rgba(40, 42, 54, 0.5)', padding: '20px', borderRadius: '12px', margin: '20px 0' }}>
              <h3 style={{ color: '#8be9fd', marginBottom: '20px', fontSize: '16px', textAlign: 'center' }}>بيانات EasyOrder</h3>
              
              <div style={fieldGroupStyle}>
                <label style={labelStyle}>دومين EasyOrder</label>
                <input 
                  type="text" 
                  name="easyOrderDomain" 
                  placeholder="مثال: mystore.easyorder.com" 
                  value={formData.easyOrderDomain} 
                  onChange={handleChange} 
                  required 
                  style={inputStyle} 
                />
              </div>
              
              <div style={fieldGroupStyle}>
                <label style={labelStyle}>Store ID</label>
                <input 
                  type="text" 
                  name="easyOrderStoreId" 
                  placeholder="Store ID" 
                  value={formData.easyOrderStoreId} 
                  onChange={handleChange} 
                  required 
                  style={inputStyle} 
                />
              </div>
              
              <div style={fieldGroupStyle}>
                <label style={labelStyle}>API Key</label>
                <input 
                  type="text" 
                  name="easyOrderApiKey" 
                  placeholder="API Key" 
                  value={formData.easyOrderApiKey} 
                  onChange={handleChange} 
                  required 
                  style={inputStyle} 
                />
              </div>
            </div>
          )}
          
          <button type="submit" disabled={loading} style={buttonStyle}>
            {loading ? 'جاري الإنشاء...' : 'إنشاء حساب'}
          </button>
        </form>
        
        {error && <p style={{ background: '#ff5555', color: '#fff', padding: '12px', borderRadius: '8px', marginTop: '20px', textAlign: 'center', fontWeight: 'bold' }}>{error}</p>}
        
        <p style={{textAlign: 'center', marginTop: '20px', color: '#f8f8f2', fontSize: '14px'}}>
          لديك حساب بالفعل؟ <Link to="/" style={{color: '#8be9fd', fontWeight: 'bold', textDecoration: 'underline'}}>سجل دخول من هنا</Link>
        </p>
      </div>
    </div>
  );
}

// Styles
const fieldGroupStyle = {
  marginBottom: '20px',
};

const labelStyle = {
  display: 'block',
  marginBottom: '8px',
  color: '#f8f8f2',
  fontWeight: '600',
  fontSize: '14px',
};

const inputStyle = {
  width: '100%',
  padding: '12px 15px',
  border: '2px solid #44475a',
  borderRadius: '8px',
  fontSize: '14px',
  transition: 'all 0.3s ease',
  direction: 'ltr',
  textAlign: 'left',
  boxSizing: 'border-box',
  background: '#282a36',
  color: '#f8f8f2',
};

const buttonStyle = {
  width: '100%',
  padding: '15px',
  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  color: 'white',
  border: 'none',
  borderRadius: '10px',
  fontSize: '16px',
  fontWeight: 'bold',
  cursor: 'pointer',
  transition: 'all 0.3s ease',
  marginTop: '20px',
};

export default SignupPage;